module.exports = __webpack_public_path__ + "img/power.d04360b8.svg";